
import { Vue, Component } from 'vue-property-decorator';
import tumsAxiosPost from '@/model/action';
import PROJECTMANAGE from '@/model/projectManage';
import COMMON from '@/model/common';
const {
    TumsDialog,
    TumsButton,
    Utils
} = window['tums-components'].default;
const { tumsAxios } = Utils.data;
@Component({
    components: {
        TumsDialog,
        TumsButton
    }
})
export default class HeaderTail extends tumsAxiosPost {
    newProject = false;
    username = 'admin';

    backTums() {
        if (window.location.href.includes('newProject')) {
            this.newProject = true;
        } else {
            window.location.assign(window.location.origin);
        }
    }

    exitConfirm(exit:boolean) {
        this.newProject = false;
        if (exit) {
            if (this.$route.query.projectId && this.$route.query.projectName) {
                this.tumsAxiosPost(PROJECTMANAGE.url.deleteProject, {
                    projectId: this.$route.query.projectId
                }, (data:any) => {
                    window.location.assign(window.location.origin);
                });
            } else {
                window.location.assign(window.location.origin);
            }
        }
    }

    getCurrentUser() {
        tumsAxios.post(COMMON.url.getCurrentUser, {}, (res:any) => {
            this.username = res.result.username;
        });
    }

    mounted() {
        this.getCurrentUser();
    }
};
